/* eslint-disable radix */
import React from 'react';

const ProgressIndicator = ({ progress, overdue }) => {
  const styles = {
    width: `${progress}%`,
    backgroundColor: progress > 50 ? '#008A1F' : '#FFC107',
  };

  const overdueStyles = {
    width: `${progress}%`,
    backgroundColor: '#DA3418',
  };
  return (
    <div className="JourneyReportingProgressIndicator">
      <div className="JourneyReportingProgressIndicator-outer">
        <div
          className="JourneyReportingProgressIndicator-inner"
          style={overdue ? overdueStyles : styles}
        />
      </div>
      {`${parseInt(progress)}%`}
    </div>
  );
};

export default ProgressIndicator;
